import Constants from 'common/constants'

import {GET_BRANCH} from './ActionTypes/ApiActionTypes'
import {REDUX_SET_BRANCHES} from './ActionTypes/ReduxActionTypes'

export const getBranches = (body, onSuccess, onFailure) => {
  return {
    type: GET_BRANCH,
    payload: {
      apiUrl: Constants.api_get_branches,
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      body,
      reduxActionType: REDUX_SET_BRANCHES,
      onSuccess,
      onFailure,
    },
  }
}
